import { createFileRoute } from '@tanstack/react-router';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonSheet } from '@/components/feedback/skeletons';
import { PageHeader } from '@/components/page-header';
import {
  TransactionActions,
  TransactionAlert,
  TransactionMeta,
  TransactionSections,
  TransactionStatus,
  useTransactionDetail,
} from '@/components/transactions/transaction-detail';
import { describeTransaction } from '@/lib/transactions';

export const Route = createFileRoute('/_app/transactions/$transactionId')({
  component: TransactionPage,
});

/** The full page of one transaction: the same detail the sheet shows. */
function TransactionPage() {
  const { transactionId } = Route.useParams();
  const detail = useTransactionDetail(transactionId);
  return (
    <QueryState
      query={detail}
      label="this transaction"
      skeleton={<SkeletonSheet />}
    >
      {(tx) => (
        <div className="flex max-w-4xl flex-col gap-6">
          <PageHeader
            title={describeTransaction(tx)}
            description="Corrections are change requests that a second person approves."
            actions={<TransactionActions tx={tx} />}
          />
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
            <TransactionStatus tx={tx} />
            <TransactionMeta tx={tx} />
          </div>
          <TransactionAlert tx={tx} />
          <TransactionSections tx={tx} />
        </div>
      )}
    </QueryState>
  );
}
